"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorSerializer = void 0;
/*
 * This function dumps long stack traces for exceptions having a cause()
 * method. The error classes from
 * [verror](https://github.com/davepacheco/node-verror) and
 * [restify v2.0](https://github.com/mcavage/node-restify) are examples.
 *
 * Based on `dumpException` in
 * https://github.com/davepacheco/node-extsprintf/blob/master/lib/extsprintf.js
 */
function getFullErrorStack(ex) {
    var ret = ex.stack || ex.toString();
    if (ex.cause && typeof (ex.cause) === 'function') {
        var cex = ex.cause();
        if (cex) {
            ret += '\nCaused by: ' + getFullErrorStack(cex);
        }
    }
    return (ret);
}
/**
 * We need to serialize any error objects.
 * Otherwise, they will show as empty objects in logs.
 */
function errorSerializer(error) {
    if (!error || !error.stack) {
        return error;
    }
    var obj = {
        message: error.message,
        name: error.name,
        stack: getFullErrorStack(error),
        code: error.code,
        signal: error.signal,
        uncaught: error.uncaught || null,
        requestMethod: error.requestMethod || null,
        requestUrl: error.requestUrl || null,
        returnRequestId: error.returnRequestId || null,
        requestId: error._id || null,
        parentRequestId: error._parentId || null,
        transactionId: error._transactionId || null,
        instigator: error.instigator || null,
        instigatorStatus: error.instigatorStatus || null,
        errorCode: error.errorCode || null,
        statusCode: error.statusCode || null,
        downstream: error.downstream || false,
    };
    return obj;
}
exports.errorSerializer = errorSerializer;
